/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { WebsocketService } from '../services/websocket.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private websocketService: WebsocketService,
  ) {}

  canActivate(): boolean {
    if (this.authService.isLoggedIn()) {
      if (this.authService.getUsername()) {
        this.websocketService.ensureConnected(this.authService.getUsername()!);
      }

      return true;
    } else {
      this.router.navigate(['/admin/login']);
      return false;
    }
  }
}
